import React, { useState }                      from 'react';
import { Button }                               from 'react-bootstrap';
import { useSelector }                          from 'react-redux';
import moment                                   from 'moment';

import { APROBADA, AGENDADA }                   from '../../../../data/audienceStates';
import { EDITAR_OFIJU, SOLICITUDES_MODIFICAR }  from '../../../../data/objects';
import { ICON_EDIT, ICON_OFIJU }                from '../../../extras/icons';

import Authorities                              from '../../../../services/AuthoritiesService';
import OfijuForm                                from '../treatment/forms/OfijuForm';
import ProsecutorEditForm                       from '../treatment/forms/ProsecutorEditForm';



const AudienceInfo = () => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Accedo al store
    const audience = useSelector(state => state.audiences.audienceWork);
    const authorities = useSelector(state => state.auth.authorities);

    // Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    const [showEditOfiju, setShowEditOfiju] = useState(false);



    // --------------------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    // Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    // Manejo la apertura
    const handleOpenOfiju = () => {
        setShowEditOfiju(true);
    }
    // Manejo el cierre
    const handleCloseOfiju = () => {
        setShowEditOfiju(false);
    }

    // Analizo si puede editar
    let canEdit = false;
    let canEditOfiju = false;
    if(audience)
    {   //Edicicón de datos
        if(audience.estado && audience.estado.id >= APROBADA && audience.estado.id <= AGENDADA)
        {   //Verifico permisos
            if(authorities && Authorities.hasPermission(authorities, SOLICITUDES_MODIFICAR))
            {   //Puede editar
                canEdit = true;
            }
        }
        //Edición de ofiju
        if(audience.estado && audience.estado.id === APROBADA)
        {   //Verifico permisos
            if(authorities && Authorities.hasPermission(authorities, EDITAR_OFIJU))
            {   //Puede editar
                canEditOfiju = true;
            }
        }
    }
    
    

    // --------------------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">Datos de la Audiencia</h6>
                    <div className="dropdown no-arrow">

                        {   canEditOfiju 
                                ?
                                    <React.Fragment>
                                        <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpenOfiju}>
                                            <ICON_OFIJU />
                                        </Button>
                                        <OfijuForm
                                            show = { showEditOfiju }
                                            handleClose = { handleCloseOfiju }
                                            audience = { audience }
                                        />
                                    </React.Fragment>
                                : 
                                    null
                        }
                        {   canEdit 
                                ?
                                    <React.Fragment>
                                        <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                            <ICON_EDIT />
                                        </Button>
                                        <ProsecutorEditForm
                                            show = { showEdit }
                                            handleClose = { handleClose }
                                            audience = { audience }
                                        />
                                    </React.Fragment>                            
                                : 
                                    null
                        }
                    </div>
                </div>
                <div className="card-body">
                {   audience && audience.solicitante 
                        ?
                            <div className="h6 mb-0 font-weight-bold text-gray-800">
                                <div className="row">
                                    <div className="col-md-2 mb-1">
                                        <small>F. SOLICITUD:</small>
                                        <br/>
                                        { audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }
                                    </div>
                                    <div className="col-md-10 mb-1">
                                        <small>SOLICITANTE:</small>
                                        <br/>
                                        { audience.solicitante.descripcion } <small>{ audience.usuario ? `(${audience.usuario.apellido}, ${audience.usuario.nombre})` : '' }</small>
                                    </div>
                                    <div className="col-12 mb-1">
                                        <small>EXPEDIENTE:</small>
                                        <br/>
                                        { audience.expediente ? audience.expediente.numero : null } { audience.caratula }
                                    </div>
                                    <div className="col-12 mb-1">
                                        <small>TIPO/S DE AUDIENCIA:</small>
                                        <br/>
                                        {   audience.audienciaTipoList.map( (type,index)=>(
                                                <React.Fragment key={`aiat${type.id}`}>
                                                    {`${index > 0 ? ', ' : ''}${type.descripcion}`}
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                    <div className="col-md-6 mb-1">
                                        <small>UNIDAD FISCAL:</small>
                                        <br/>
                                        { audience.fiscalia ? audience.fiscalia.descripcion : '' }
                                    </div>
                                    <div className="col-md-6 mb-1">
                                        <small>FISCAL:</small>
                                        <br/>
                                        { audience.fiscal ? `${audience.fiscal.apellido}, ${audience.fiscal.nombre}` : 'S/D' }
                                    </div>
                                    {   audience.ofiju 
                                            ?
                                                <div className="col-12 mb-1">
                                                    <small>OFIJU:</small>
                                                    <br/>
                                                    { audience.ofiju.nombre }
                                                </div>
                                            : 
                                                null
                                    }
                                    {   audience.vencimientoIPP 
                                            ?
                                                <div className="col-12 mb-1">
                                                    <small>Vencimiento de IPP:</small>
                                                    <br/>
                                                    <span className='text-danger'>{ moment(audience.vencimientoIPP).format('DD/MM/YYYY') }</span>
                                                </div>
                                            : 
                                                null
                                    }
                                    {   audience.observacionSolicitante 
                                            ?
                                                <div className="col-12 mb-1">
                                                    <small>OBSERVACIONES DEL SOLICITANTE:</small>
                                                    <br/>
                                                    { audience.observacionSolicitante }
                                                </div>
                                            : 
                                                null
                                    }
                                </div>
                            </div>
                        : 
                            null
                    }
                </div>
            </div>
        </div>
        );
    };
    
    export default AudienceInfo;